import React from "react";
import { Box, Grid2 } from "@mui/material";
import HeaderComponent from "../../HeaderComponent/HeaderComponent";
import RecentItems from "../../RecentActivities/RecentActivitiesAndInsight";
import WasteCollectionTypeBarsDataset from "../../WasteCollection/WasteGraph";
import LitterBinsPlot from "../LitterBins/LitterBinsPlot";

const WasteCollectionType: React.FC = () => {
  return (
    // <Box sx={{ width: "100%", backgroundColor: "red" }}>
    //   <HeaderComponent />
    //   <Grid2 container spacing={2} style={{ height: "100vh" }}>
    //     <Grid2 size={{ xs: 9, sm: 9, md: 8.5, xl: 8.5, lg: 8.5 }}>
    //       <WasteCollectionTypeBarsDataset />
    //     </Grid2>
    //     <Grid2 size={{ xs: 3, sm: 3, md: 3.5, xl: 3.5, lg: 3.5 }}>
    //       <RecentItems />
    //     </Grid2>
    //   </Grid2>
    // </Box>

    <Box sx={{ px: "10px", mt: 10.5 }}>
      <HeaderComponent />
      <Grid2 container spacing={2} style={{ height: "100vh" }}>
        <Grid2 size={{ xs: 9, sm: 9, md: 8.5, xl: 8.5, lg: 8.5 }}>
          <WasteCollectionTypeBarsDataset />
        </Grid2>
        <Grid2 size={{ xs: 3, sm: 3, md: 3.5, xl: 3.5, lg: 3.5 }}>
          <RecentItems />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default WasteCollectionType;
